<template>
  <b-modal
    id="modal-topup-kompay"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    hide-header
    hide-footer
    :dialog-class="isKomcardUser && !isKomshipUser ? 'custom-modal-topup' : ''"
    centered
  >
    <p class="text-2xl text-center font-semibold my-1 mb-2 text-black">
      Top Up
    </p>
    <b-form
      class="mb-1"
      @submit.prevent="topUpBalance()"
    >
      <div class="mb-1 border border-gray-200 rounded-md py-2 ps-4">
        <label
          class="font-semibold text-md mb-1 block text-black"
        >Saldo Kompay</label>
        <div class="text-2xl font-bold text-black">
          {{ IDR(saldo) }}
        </div>
      </div>
      <b-form-group>
        <label
          for="nominalTopUp"
          class="font-semibold"
        >Nominal</label>
        <ValidationProvider
          #default="{ errors }"
          name="nominal"
          :rules="{ min_value: accumulationMinimalBalanceWithKompay }"
        >
          <b-form-input
            id="nominalTopUp"
            v-model="nominalTopUp"
            :state="errors.length > 0 ? false : null"
            placeholder="Masukkan nominal disini"
            class="text-lg"
            @keypress="isNumber($event)"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </ValidationProvider>
        <div class="flex items-center mt-1">
          <div class="flex items-center bg-[#DFF3FF] p-2 rounded-md w-full">
            <img
              class="mr-[8px]"
              src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
              alt="info"
            >
            <div class="flex-row">
              <h1 class="text-lg text-black text-bold mb-0">
                Saldo Minimal {{ IDR(minimalBalanceKompay) }}
              </h1>
              <span
                class="text-sm text-black"
              >Top up sekarang dan rasakan kemudahan layanan Komads
                Whitelisted</span>
            </div>
          </div>
        </div>
      </b-form-group>
      <div
        v-show="isKomcardUser && !isKomshipUser"
        class="mb-1"
      >
        <div class="bg-[#DFF3FF] p-1">
          <div class="grid grid-cols-4 items-center">
            <div class="col-span-3 w-fit">
              <span class="flex items-center gap-1">
                <span>
                  <img
                    width="26"
                    src="https://storage.googleapis.com/komerce/assets/logo/logo-komship-chat.svg"
                    alt="logo-komship"
                    srcset=""
                  ></span>

                <span
                  class="font-semibold text-[16px] leading-none tracking-normal align-middle text-[#333333]"
                >Stop Ribet Top Up, Yuk Pakai Komship!</span>
              </span>
              <span
                class="text-sm font-normal leading-none tracking-normal align-middle"
              >
                Bayangin Kamu pakai Komship sebagai agregator <br>
                pengiriman COD, saldo di KomPay akan terus terisi <br>
                otomatis.
              </span>
            </div>
            <div class="grid justify-start">
              <b-button
                href="https://komship.id"
                target="_blank"
                size="sm"
                class="text-nowrap"
                variant="outline-primary"
              >
                Coba Sekarang
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <b-row>
        <b-col cols="6">
          <b-btn
            variant="outline-primary"
            block
            :disabled="loadingTopUp"
            class="font-medium"
            @click="$emit('close')"
          >
            Batal
          </b-btn>
        </b-col>
        <b-col cols="6">
          <b-btn
            type="submit"
            variant="primary"
            block
            :disabled="
              Number.isNaN(formatNumber(nominalTopUp)) ||
                formatNumber(nominalTopUp) <
                accumulationMinimalBalanceWithKompay ||
                loadingTopUp
            "
            class="font-medium"
          >
            <b-spinner
              v-if="loadingTopUp"
              class="mr-[6px]"
              small
            />
            Top Up Sekarang
          </b-btn>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import { IDR } from '@/libs/currency'
import { isNumber } from '@/libs/helpers'
import { mapState } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import { ValidationProvider, extend } from 'vee-validate'
import moment from 'moment'
import { newAxiosIns } from '@/libs/axios'

// Extend validation rule for minimum value
extend('min_value', {
  validate: (value, { min_value }) => {
    const numValue = parseFloat(value.replace(/[^0-9,-]+/g, ''))
    return numValue >= min_value
  },
  params: ['min_value'],
  message: (_, { min_value }) => `Minimal topup ${IDR(min_value)}`,
})

export default {
  name: 'ModalTopupKompay',
  components: {
    ValidationProvider,
  },
  props: {
    platform: {
      type: String,
      default: 'meta',
    },
  },
  data() {
    return {
      isNumber,
      IDR,
      loadingTopUp: false,
      isKomcardUser: this.$store.state.dashboard.profile.is_komcards === 1,
      isKomshipUser: this.$store.state.dashboard.profile.is_komship === 1,
      messageTopup: '',
      isWeekend: false,
      subscriptionStatus: null,
      feeTopup: 0,
      minimalSubscriptionFee: 0,
    }
  },
  computed: {
    ...mapState('saldo', ['saldo']),
    ...mapFields('saldo', [
      'nominalTopUp',
      'selectedRekTujuan',
      'nominal',
      'pin',
    ]),
    getMinimalBalancePlatform() {
      const minimalBalance = {
        meta: 300000,
        google: 300000,
        tiktok: 500000,
      }

      return minimalBalance[this.platform]
    },

    /**
     * Accumulation of minimal balance with KomPay
     * @returns {Number} Accumulation of minimal balance with KomPay
     */
    accumulationMinimalBalanceWithKompay() {
      return Math.max(0, this.minimalBalanceKompay - this.saldo)
    },

    minimalBalanceKompay() {
      const baseAmount = this.getMinimalBalancePlatform || 0
      const feePercentage = this.feeTopup || 0

      const feeAmount = baseAmount * (feePercentage / 100)

      const subFee = this.subscriptionStatus ? this.minimalSubscriptionFee : 0

      return baseAmount + feeAmount + subFee
    },
  },
  watch: {
    nominalTopUp(newValue) {
      const result = newValue
        .replace(/\D/g, '')
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      this.$nextTick(() => {
        this.nominalTopUp = `Rp ${result}`
      })
    },
    // When the parent updates the `platform` prop (for example before
    // showing the modal), re-fetch the platform-specific data.
    platform(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.getWhitelistRequestInfo()
        this.getMinimalSubscriptionFee()
      }
    },
  },
  mounted() {
    this.$store.dispatch('saldo/getBalanceSummary')
  },
  methods: {
    /**
     * Format input value to number
     * @param {string} value - Input value to format
     * @returns {number} - Formatted number
     */
    formatNumber(value) {
      if (!value) return 0
      return Number(value.toString().replace(/[^0-9]/g, ''))
    },

    /**
     * Show modal top up
     */
    showModal() {
      this.nominalTopUp = ''

      if (this.platform) {
        this.getWhitelistRequestInfo()
        this.getMinimalSubscriptionFee()
      }

      this.$bvModal.show('modal-topup-kompay')
    },

    /**
     * Hide modal top up
     */
    hideModal() {
      this.$bvModal.hide('modal-topup-kompay')
    },

    async getWhitelistRequestInfo() {
      await newAxiosIns
        .get('/komads/api/v1/partners/whitelist_request_info', {
          params: {
            platform_name: this.platform,
          },
        })
        .then(response => {
          const { data } = response.data

          this.subscriptionStatus = data.subscription_status
          this.feeTopup = data.fee_topup
        })
        .catch(() => {
          this.subscriptionStatus = null
          this.feeTopup = 0
        })
    },

    async getMinimalSubscriptionFee() {
      await newAxiosIns
        .get('/komads/api/v1/subscription_fees', {
          params: {
            platform_name: this.platform,
          },
        })
        .then(response => {
          const { data } = response.data

          this.minimalSubscriptionFee = data[0].price
        })
        .catch(() => {
          this.minimalSubscriptionFee = 0
        })
    },

    /**
     * Check if current date is weekend or holiday
     */
    getWeekend() {
      const day = moment().day() // 0 = Minggu, 1 = Senin, ..., 6 = Sabtu
      const today = moment()
      const month = today.month() + 1 // Bulan sekarang (1-12)
      const todayDate = today.date() // Tanggal hari ini (1-31)
      const holidays = {
        1: ['27', '29'],
        3: ['31'],
        5: ['12'],
        6: ['9', '30'],
      }

      // ** Kondisi 2: Validasi Tanggal Merah **
      const currentHolidays = holidays[month]
        ? holidays[month].map(date => moment(`${month}-${date}`, 'M-D'))
        : []
      const holidayMatch = currentHolidays?.find(holiday => holiday.isSame(today, 'day'))

      this.isWeekend = (day >= 4 && day <= 6)
        || holidayMatch
        || (todayDate >= 1 && todayDate <= 7)

      if (todayDate >= 1 && todayDate <= 7) {
        // Kondisi tambahan jika today adalah tanggal 1 - 7
        this.messageTopup = `1 - 7 ${today.format('MMMM YYYY')}`
      } else if (day >= 4 && day <= 6) {
        // Kamis (4), Jumat (5), Sabtu (6)
        const startOfWeek = today
          .clone()
          .startOf('isoWeek')
          .add(3, 'days')
        const endOfWeek = today
          .clone()
          .startOf('isoWeek')
          .add(5, 'days')
        this.messageTopup = `${startOfWeek.format('D')} - ${endOfWeek.format(
          'D MMMM YYYY',
        )}`
      } else if (holidayMatch) {
        const twoDaysBefore = holidayMatch.clone().subtract(2, 'days')
        this.messageTopup = `${twoDaysBefore.format(
          'D',
        )} - ${holidayMatch.format('D MMMM YYYY')}`
      } else {
        this.messageTopup = 'tidak ada biaya admin'
      }

      this.$emit('update:isWeekend', this.isWeekend)
      this.$emit('update:messageTopup', this.messageTopup)
    },

    /**
     * Process top up balance
     */
    async topUpBalance() {
      if (this.formatNumber(this.nominalTopUp) > 500000) {
        this.loadingTopUp = true
        try {
          const response = await this.$store.dispatch('saldo/newTopUpSaldo')
          const { data } = response
          if (!data.status) throw data
          try {
            window.open(data.data.invoice_url, '_blank').focus()
          } catch (e) {
            this.hideModal()
            this.loadingTopUp = false
            this.$toast_error({
              message:
                'Pop-up Blocker diaktifkan! Harap tambahkan situs ini ke daftar pengecualian Anda.',
            })
          }
          this.hideModal()
          this.loadingTopUp = false
          this.$swal({
            html:
              'Silahkan selesaikan pembayaran terlebih dahulu untuk memastikan proses Top Up Saldo Berhasil<br><br><b>Sudah menyelesaikan pembayaran?</b>',
            imageUrl:
              'https://storage.googleapis.com/komerce/assets/icons/warning.svg',
            confirmButtonText: 'Cek Rincian Saldo',
            confirmButtonClass: 'btn btn-primary',
          }).then(then => {
            if (then.isConfirmed) {
              this.$router.push('/keuangan/saldo/detail')
            }
          })
        } catch (e) {
          this.hideModal()
          this.loadingTopUp = false
          this.$swal({
            title: '<span class="font-semibold h4">Top Up Saldo Gagal</span>',
            text: e.message,
            imageUrl:
              'https://storage.googleapis.com/komerce/assets/icons/fail.svg',
            confirmButtonText: 'Oke',
            confirmButtonClass: 'btn btn-primary',
          })
        } finally {
          this.$store.commit('saldo/UPDATE_NOMINAL', '')
        }
      } else {
        this.hideModal()
        this.getWeekend()
        this.$emit('showPaymentMethod')
      }
    },
  },
}
</script>
